<template>
  <div :class="context.classes.element" :data-type="context.type">
    <t-button
      :type="context.type"
      :action="() => null"
      :disabled="context.value"
      :loading="context.value"
      >{{ context.label || context.name || "Submit" }}</t-button
    >
  </div>
</template>

<script>
import FormulateInputMixin from "@braid/vue-formulate/src/FormulateInputMixin";
import TButton from "@/components/Layout/Button";

export default {
  components: { TButton },
  name: "FormSubmit",
  mixins: [FormulateInputMixin],
};
</script>
